import { AppUrlConstant } from './app-url';

export class NavigationUrl {
    // User Module Urls
    private static readonly PUBLIC = `${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.PUBLIC}`;
    public static readonly LOGIN = `${this.PUBLIC}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.LOGIN}`;
    public static readonly RESET_PASSWORD = `${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.RESET_PASSWORD}`;

    //Dashboard Module Urls
    public static readonly DASHBOARD = `${AppUrlConstant.DASHBOARD}`;

    // Error Module Navigation Urls
    public static readonly UNAUTHORIZED = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.UNAUTHORIZED}`;
    public static readonly PAGE_NOT_FOUND = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.PAGE_NOT_FOUND}`;
    public static readonly INTERNAL_SERVER_ERROR = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.INTERNAL_SERVER_ERROR}`;
    public static readonly FORBIDDEN = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.FORBIDDEN}`;
    public static readonly BAD_GATEWAY = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.BAD_GATEWAY}`;
    public static readonly SERVICE_UNAVAILABLE = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.SERVICE_UNAVAILABLE}`;
    public static readonly API_GATEWAY_TIMED_OUT = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.TIMED_OUT}`;
    public static readonly BAD_REQUEST = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.BAD_REQUEST}`;
    public static readonly ERROR = `${AppUrlConstant.ERROR}`;

    // Below navigation url is used when before login api gives CORS error or login api gives CORS error it is mainly because the request came from the invalid domain url;
    public static readonly INVALID_DOMAIN_URL = `${AppUrlConstant.ERROR}${AppUrlConstant.URL_SEPARATOR}${AppUrlConstant.INVALID_DOMAIN_URL}`;
}
